// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NavPagination_wrap_Dv7EL","control":"NavPagination_control_1kX1O","is-disabled":"NavPagination_is-disabled_1Qf5t","status":"NavPagination_status_1ZFkC"};